import { render, staticRenderFns } from "./ArticleSelectField.vue?vue&type=template&id=bca66a9e&scoped=true"
import script from "./ArticleSelectField.vue?vue&type=script&lang=ts"
export * from "./ArticleSelectField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca66a9e",
  null
  
)

export default component.exports